var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laptop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.588,
    height: 46.849,
    viewBox: "0 0 65.588 46.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M60.9,9.37V2.342A2.342,2.342,0,0,0,58.561,0H7.027A2.342,2.342,0,0,0,4.685,2.342V32.794A4.685,4.685,0,0,0,0,37.479v2.342a7.027,7.027,0,0,0,7.027,7.027H60.9a4.685,4.685,0,0,0,4.685-4.685V14.055A4.685,4.685,0,0,0,60.9,9.37ZM9.37,4.685H56.219V9.37H44.506a4.685,4.685,0,0,0-4.685,4.685V34.176l-.96.96H26.727l-1.64-1.663a2.342,2.342,0,0,0-1.663-.679H9.37ZM7.027,42.164a2.342,2.342,0,0,1-2.342-2.342V37.479H22.464l1.64,1.663a2.342,2.342,0,0,0,1.663.679H39.822v2.342Zm53.876,0h-16.4V14.055H60.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.685,0H2.342a2.342,2.342,0,1,0,0,4.685H4.685A2.342,2.342,0,1,0,4.685,0Z",
    transform: "translate(49.191 35.137)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.5f88043eee69551b7cb53d24b80f63aa.svg";
export { ForwardRef as ReactComponent };